import type { IconSvgObject } from './types';

const LocationFavourite01Icon: IconSvgObject = [
  ["path", { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.7431 8.28961C13.1465 7.45704 12 8.68433 12 8.68433C12 8.68433 10.8535 7.45704 9.25685 8.2896C7.32296 9.298 7.18408 13.2469 12 15C16.816 13.2469 16.677 9.298 14.7431 8.28961Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationFavourite01Icon;
